// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pw-8";
export var editMode = "_pw-3";
export var headerRow = "_pw-a";
export var headerTitle = "_pw-b";
export var product = "_pw-1";
export var productDetails = "_pw-5";
export var productDivider = "_pw-7";
export var productImage = "_pw-2";
export var productInfo = "_pw-4";
export var productTitle = "_pw-6";
export var strikethrough = "_pw-9";
export var upsellProductsCard = "_pw-0";